import React, { useEffect, useState } from 'react';
import TaraIcon from '../../assets/images/tara.svg';

const DEFAULT_TEXT = 'Just a sec... Tara is working on it.';

interface TypingIndicatorProps {
  label?: string | null; // ADDED — live status text from the backend
}

export default function TypingIndicator({ label }: TypingIndicatorProps) {
  const fullText = label || DEFAULT_TEXT; // ADDED — fall back to default if no status yet

  const [displayText, setDisplayText] = useState('');
  const [charIndex, setCharIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  // ADDED — restart the typing animation from scratch whenever the label changes
  useEffect(() => {
    setDisplayText('');
    setCharIndex(0);
    setDeleting(false);
  }, [fullText]);

  useEffect(() => {
    const typingSpeed = 70;
    const deletingSpeed = 40;
    const pauseTime = 1000;

    let timeout: NodeJS.Timeout;

    if (!deleting && charIndex < fullText.length) {
      timeout = setTimeout(() => {
        setDisplayText(fullText.slice(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      }, typingSpeed);
    } else if (!deleting && charIndex === fullText.length) {
      timeout = setTimeout(() => setDeleting(true), pauseTime);
    } else if (deleting && charIndex > 0) {
      timeout = setTimeout(() => {
        setDisplayText(fullText.slice(0, charIndex - 1));
        setCharIndex(charIndex - 1);
      }, deletingSpeed);
    } else if (deleting && charIndex === 0) {
      setDeleting(false);
    }

    return () => clearTimeout(timeout);
  }, [charIndex, deleting, fullText]);

  return (
    <div className="flex items-center gap-3 mt-4 animate-fadeInSlow">
      <div className="relative h-8 w-8">
        <div className="absolute inset-0 rounded-full border-2 border-gray-300 border-t-purple-500 animate-spin"></div>
        <img
          src={TaraIcon}
          alt="Tara is thinking..."
          className="absolute inset-1 h-6 w-6"
        />
      </div>

      <span className="text-sm text-gray-500 italic whitespace-pre-wrap">
        {displayText}
        <span className="animate-pulse">|</span>
      </span>
    </div>
  );
}